export default __webpack_public_path__ + "static/media/medium-priority.e02b72fe.svg";